import { render, staticRenderFns } from "./SettingsSectionCard.vue?vue&type=template&id=760e0cc0&scoped=true&"
import script from "./SettingsSectionCard.vue?vue&type=script&lang=js&"
export * from "./SettingsSectionCard.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSectionCard.vue?vue&type=style&index=0&id=760e0cc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760e0cc0",
  null
  
)

export default component.exports